<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Vertical Position</span>
      <div class="wf-w-1/2">
        <select v-model="verticalPosition" class="wf-w-full">
          <option value="POSITION_TOP">Top</option>
          <option value="POSITION_MIDDLE">Middle</option>
          <option value="POSITION_BOTTOM">Bottom</option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Horizontal Position</span>
      <div class="wf-w-1/2">
        <select v-model="horizontalPosition" class="wf-w-full">
          <option value="POSITION_LEFT">Left</option>
          <option value="POSITION_CENTER">Center</option>
          <option value="POSITION_RIGHT">Right</option>
        </select>
      </div>
    </li>
  </div>
</template>

<script>
  import { HorizontalPositionClasses, VerticalPositionClasses } from '../classes/PositionClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      horizontalPositionClasses() {
        return Object.keys(HorizontalPositionClasses)
      },
      verticalPositionClasses() {
        return Object.keys(VerticalPositionClasses)
      },
      verticalPosition: {
        get() {
          let currentPosition = this.elementClasses(this.classes)[this.device].find(elementClass => this.verticalPositionClasses.includes(elementClass.value))
          if (! currentPosition) {
            currentPosition = {property: 'VerticalPosition', value: 'POSITION_BOTTOM', touched: false}
            this.addToArray(this.module, [currentPosition], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentPosition.value
        },
        set(value) {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.verticalPositionClasses.includes(elementClass.value))
          value = {property: 'VerticalPosition', value: value, touched: currentPadding.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
      horizontalPosition: {
        get() {
          let currentPosition = this.elementClasses(this.classes)[this.device].find(elementClass => this.horizontalPositionClasses.includes(elementClass.value))
          if (! currentPosition) {
            currentPosition = {property: 'HorizontalPosition', value: 'POSITION_RIGHT', touched: false}
            this.addToArray(this.module, [currentPosition], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentPosition.value
        },
        set(value) {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.horizontalPositionClasses.includes(elementClass.value))
          value = {property: 'HorizontalPosition', value: value, touched: currentPadding.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
    },
  })
</script>